<template>
	<div style="box-sizing: border-box;padding-bottom: 50px;">
		<template v-for="(item , index) in nav">
			<div :key="index" v-if="item.type!=='system'">
				<van-divider>{{item.name}}</van-divider>
				<van-grid :square="true">
					<template v-for="_item in item.children">
						<van-grid-item @click="gridClickEvent(_item)" :key="_item.no" icon="apps-o"
							:text="_item.name">
							<template #icon>
								<van-icon size="20" name="apps-o" />
							</template>
						</van-grid-item>
					</template>
				</van-grid>
			</div>
		</template>
		<van-popup v-model="childrenShow" position="bottom" :style="{ height: '30%' }">
			<van-divider v-if="currentGrid">{{currentGrid.name}}</van-divider>
			<van-grid :square="true">
				<template v-for="(item , index) in childrenGrid">
					<van-grid-item @click="gridClickEvent(item)" :key="index" v-if="item.type!=='system'" icon="photo-o"
						:text="item.name" />
				</template>
			</van-grid>
		</van-popup>
	</div>
</template>

<script>
	export default {
		props: {


		},
		mounted() {
			//window.console.log(this.item)
		},
		computed: {
			nav() {
				return this.$store.state.system.nav
			}
		},
		data() {
			return {
				childrenShow: false,
				childrenGrid: [],
				currentGrid: null
			}
		},
		methods: {
			gridClickEvent(e) {
				if (e.meta && e.meta.children.length != 0) {
					this.childrenGrid = e.meta.children
					this.currentGrid = e
					this.childrenShow = true

				} else {
					let res = this.$router.resolve({
						name: 'indexmodule',
						query: {
							name: e.controller,
							foreingKey: '{}',
							moduleName: e.name
						}
					})

					window.location.href = res.href
					//history.pushState(null, null, res.href)
				}

				// let win = window.open(res.href, 'supplier' + 'indexmodule',
				// 	this.$store.state.system.windowConfig)
				// win.onload = () => {

				// }
			},
		}
	}
</script>


<style scoped>

</style>
